<script setup lang="ts">
import { ref } from "vue";
import FloorPlan from "./FloorPlan.vue";

const showFloorplan = ref(false);
</script>

<template>
  <div>
    <FloorPlan v-if="showFloorplan" />

    <div class="text-muted small col col-lg-8 ms-auto me-auto">
      <span class="text-nowrap">
        <i class="bi-calendar" />
        Status unclear
      </span>
      <div class="vr ms-1 me-2"></div>
      <span class="text-nowrap">
        <i class="bi-calendar-check" />
        Desk free
      </span>
      <div class="vr ms-1 me-2"></div>
      <span class="text-nowrap">
        <i class="bi-calendar-week" />
        Booked part-day
      </span>
      <div class="vr ms-1 me-2"></div>
      <span class="text-nowrap">
        <i class="bi-calendar-x" />
        Booked
      </span>
      <div class="vr ms-1 me-2"></div>
      <span class="text-nowrap"> <span class="marker-me" />You </span>
      <div class="vr ms-1 me-2"></div>
      <span class="text-nowrap"> <span class="marker-stud" />Student </span>
      <div class="vr ms-1 me-2"></div>
      <span class="text-nowrap"> <span class="marker-full" />Full-time </span>
      <div class="vr ms-1 me-2"></div>
      <span class="text-nowrap"> <span class="marker-guest" />Guest </span>
      <div class="vr ms-1 me-2"></div>
      <span class="text-nowrap">
        <i class="bi-building-slash" /> Public Holiday
      </span>
      <div class="vr ms-1 me-2"></div>
      <span class="text-nowrap">
        <i class="bi-caret-left" /><i class="bi-caret-right" /> Load more
      </span>
      <div class="vr ms-1 me-2"></div>
      <span class="text-nowrap"> <i class="bi-caret-down-fill" /> Today </span>
      <div class="vr ms-1 me-2"></div>
      <span class="text-nowrap">
        <i class="bi-person-gear" /> Switch user
      </span>
      <div class="vr ms-1 me-2"></div>
      <span class="text-nowrap"> <i class="bi-gear" /> Settings </span>
      <div class="vr ms-1 me-2"></div>
      <span
        class="text-nowrap"
        role="button"
        @click="showFloorplan = !showFloorplan"
      >
        <i class="bi-map" /> Floor plan
      </span>
      <div class="vr ms-1 me-2"></div>
      <span class="text-nowrap">
        <i class="bi-keyboard" /> Use [F, H, P, C, B] keys to switch mode
      </span>
      <div class="vr ms-1 me-2"></div>
      <span class="text-nowrap">
        <i class="bi-hand-index" /> Click cell to book/free/clear desk
      </span>
    </div>
  </div>
</template>

<style scoped lang="scss">
%marker {
  height: 0.5em;
  width: 0.5em;
  display: inline-block;
  margin-right: 0.25em;
}

.marker-stud {
  @extend %marker;
  background-color: var(--colour-stud);
}

.marker-full {
  @extend %marker;
  background-color: var(--colour-full);
}

.marker-guest {
  @extend %marker;
  background-color: var(--colour-guest);
}

.marker-me {
  @extend %marker;
  background-color: rgb(var(--bs-success-rgb));
}
</style>
